import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { fonts, colors } from '../common/mixins.js';
import Button from '../common/Button.jsx';
import useMediaQuery from '@mui/material/useMediaQuery';

const Container = styled.div`
  width: 100%;
  padding:16px;
  background-color:white;
  border-radius:8px;
`;

const Title = styled.div`
  ${fonts.normalTextBold()};
  padding-bottom:16px;
  border-bottom:1px solid #EDF1F6;
`;

const FlexContainer = styled.div`
  padding-top:16px;
  width: 100%;
  display: flex;
  flex-direction:row;
  gap:24px;
  justify-content:space-between;
    @media (max-width: 600px) {
      flex-direction:column;
  }
`;

const Left = styled.div`
  display: flex;
  flex-direction:column;
  gap:16px;
  ${fonts.normalTextSmall()};
`;

const Right = styled.div`
  display: flex;
  flex-direction:column;
  justify-content:space-between;
  align-items:flex-end;
  gap:12px;
  @media (max-width: 600px) {
      flex-direction:column;
      align-items:center;
      justify-content:center;
  }
`;

const Code = styled.div`
padding:8px 16px;
border-radius:8px;
background-color:${colors.otherGray};
${fonts.normalTextBold()};
 @media (max-width: 600px) {
      width:100%;
     text-align:center;
  }
`;

const AccessCode= () => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const contentId = document.getElementById('OrderContentId').value;
    const [code, setCode] = useState('');
    const [streamingUrl, setStreamingUrl] = useState('');
    const fetchData = async (contentId) => {
        try {
            const response = await fetch(`/_api/orders/get-StreamingInfo`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(contentId)
            });

            const data = await response.json();
            setCode(data.code);
            setStreamingUrl(data.streamingUrl);
               
          
        } catch (error) {
            console.error(`Error fetching streaming info`, error);
        }
    }

    useEffect(() => {
        if (contentId) {
            fetchData(contentId);
        }   
    }, [contentId]);
    return (
        <Container>
            <Title>{orderdetails_resources.AccessCode}</Title>
            <FlexContainer>
                <Left>
                    <div>{orderdetails_resources.WatchYourContent}</div>
                    <div><strong>{orderdetails_resources.HaveFun}</strong></div>
                </Left>
                <Right>
                    <Code><span id="streamingCode">{code}</span></Code>
                   <Button type='primary' height={"32px"} text={orderdetails_resources.WatchOnline} fullWidth={isMobile} url={streamingUrl} />
                </Right>
            </FlexContainer>
        </Container>
    );
}; 

export default AccessCode;
